import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { photosShow } from "../../../helpers/photosShow";
import { dateFormat, servicePlansUploadDir } from "../../../config";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import moment from "moment";
import CommonTable from "../../CommonTable/CommonTable";
import CustomPagination from "../../CustomPagination/CustomPagination";
import { getPurchaseServicePlanValue } from "../../../helpers/GetDynamicItemName/dynamicHomeValue";

import { PlanHistoryArrow } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";

import bt from '../../../components/commonStyle.css';
import messages from '../../../locale/jsonMessages';
import s from './PurchaseServiceHistory.css'

const PurchaseServiceHistory = (props) => {
    const { data, count, refetch } = props;
    const intl = useIntl();
    let path = photosShow(servicePlansUploadDir);
    const [currentPage, setCurrentPage] = useState(1);
    const [userType, setUserType] = useState('');

    const setStateVariable = (variables) => {
        if (variables.currentPage !== undefined) {
            setCurrentPage(variables.currentPage);
        }
        setUserType(variables?.userType);
    };
    const thead = () => [
        { data: intl.formatMessage(messages.planLabel) },
        { data: intl.formatMessage(messages.priceLabel) },
        { data: intl.formatMessage(messages.duration) },
        { data: intl.formatMessage(messages.status) },
        { data: intl.formatMessage(messages.StartDate) },
        { data: intl.formatMessage(messages.EndDate) },
    ];

    const tbody = () =>
        data?.map((value, key) => {
            const planDetails = JSON.parse(value?.dynamicServicePlanDetails || '[]');
            const matchPlan = getPurchaseServicePlanValue(planDetails, intl?.locale)
            const planName = matchPlan?.planName ? matchPlan?.planName : value?.servicePlanName;
            return {
                id: key,
                data: [
                    {
                        data: <div className={s.purchaseHistoryPlanInfo}>
                            <div className={s.purchaseHistoryPlanHead}>
                                {value?.servicePlanData && (
                                    <div className={s.purchaseHistoryPlanImgBox}>
                                        <img src={path + value?.servicePlanData?.mediaImage} alt={value?.servicePlanName} className={s.purchaseHistoryPlanImg} />
                                    </div>
                                )}
                                <div className={s.purchaseHistoryPlanTitle}>{planName}</div>
                            </div>
                            <ul className={s.purchaseHistoryPlanFeatureList}>
                                {value?.serviceFee >= 0 && (<li className={s.purchaseHistoryPlanListItem}>
                                    <PlanHistoryArrow className="purchaseHistoryPlanListItemSvgIcon" />
                                    <span>
                                        <span>{value?.serviceFee}%&nbsp;</span>
                                        <span>{intl.formatMessage(messages.serviceFee)}</span>
                                    </span>

                                </li>
                                )}
                                {value?.serviceAIFeature && (
                                    <li className={s.purchaseHistoryPlanListItem}>
                                        <PlanHistoryArrow className="purchaseHistoryPlanListItemSvgIcon" />
                                        <span><FormattedMessage  {...messages.aiFeatureLabel} /></span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    },
                    {
                        data: (<CurrencyConverter
                            amount={value?.price}
                            from={value?.currency} />)
                    },
                    { data: <div>{value?.duration} {value?.duration == 1 ? intl.formatMessage(messages.month) : intl.formatMessage(messages.monthsLabel)} </div> },
                    {
                        data: value?.servicePlanStatus == 'active' ? <span className='verifiedText'>{intl.formatMessage(messages.activeLabel)}</span> :
                            (value?.servicePlanStatus == 'cancelled' ? <span className='cancelStatusText'>{intl.formatMessage(messages.cancelledServicePlanLabel)}</span> :
                                intl.formatMessage(messages.expiredPlanLabel))
                    },
                    { data: moment(parseInt(value?.startDate)).format('L') },
                    { data: moment(parseInt(value?.endDate)).format('L') },
                ]
            }
        });

    const paginationData = (newPage) => {
        const variables = { currentPage: newPage, userType };
        setStateVariable(variables);
        refetch(variables);
    };

    const tableFilter = () => {
        return [
            { value: "", label: intl.formatMessage(messages.allUserTypeLabel) },
            { value: "renter", label: intl.formatMessage(messages.guest) },
            { value: "owner", label: intl.formatMessage(messages.host) }
        ]
    };

    const handleDropDown = (e) => {
        const variables = { userType: e.target.value, currentPage: 1 };
        setStateVariable(variables);
        refetch(variables)
    };
    return (
        <>
            <CommonTable
                title={intl?.formatMessage(messages.purchaseHistoryLabel)}
                tableWrapperTitle={cx(bt.commonSubTitleText, bt.fontWeightBold, bt.spaceBottom3)}
                thead={thead}
                tbody={tbody}
                filterOption={(tableFilter())}
                className={'payoutListTable purchaseHistoryTable'}
                handleFilter={(e) => handleDropDown(e)}
                filterValue={userType}
            />
            {count > 0 && (
                <CustomPagination
                    total={count}
                    currentPage={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={5}
                    change={paginationData}
                    paginationLabel={intl.formatMessage({ id: (count > 1 ? 'purchaseHistoriesLabel' : 'purchaseHistoryLabel') })}
                    isScroll
                />
            )}
        </>
    )
}

export default withStyles(bt, s)(PurchaseServiceHistory);
